import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/styles/index.scss";

import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

console.log(
  "%c👋 Hey there, curious dev!",
  "color: #9bdd75; font-size: 22px; font-weight: 700; font-family: monospace;",
);
console.log(
  "%cYou found the easter egg.\n\nThis site was hand-crafted with React, GSAP & a lot of 🍵\nLike what you see? Let's connect:\n→ https://www.linkedin.com/in/yani-degrande\n→ https://github.com/Gametodie2",
  "color: #444; font-size: 13px; line-height: 2; font-family: monospace;",
);
